// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentationPanel-container-3dr0Cn","content":"DocumentationPanel-content-3lOf4W","list":"DocumentationPanel-list-20u37R"};